import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const CourtPreviewWrapper = styled.div`
  display: contents;

  .court-preview-modal {
    .modal-content {
      max-width: 1000px;
      max-height: 100dvh;
      margin: 0 20px;
      padding: 4px 20px 12px;

      .close-button {
        font-size: 32px;

        @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
          font-size: 28px;
        }
      }
    }
  }

  .overflow-ellipsis {
    max-width: 100%;
    line-height: 20px;

    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;

    overflow: hidden;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .court-name {
    text-align: center;
    margin-bottom: 12px;
    margin-right: 20px;
  }

  .no-court-image {
    width: 500px;
    height: 50px;

    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      width: 350px;
    }

    @media only screen and (max-width: ${sizeStandards.screen.XS - 60}px) {
      width: 200px;
      height: 30px;
    }
  }

  .court-info {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    width: 100%;
    align-items: start;

    .court-contacts,
    .court-address,
    .price-info {
      min-width: 0;
      box-sizing: border-box;
      text-align: center;
    }

    .court-contacts,
    .court-address {
      overflow: hidden;
      overflow-wrap: anywhere;
      word-break: break-word;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 6;
      line-clamp: 6;

      line-height: 20px;
    }

    .court-contacts {
      padding: 0 8px;
      white-space: pre-wrap;
    }

    .court-address {
      padding: 0 8px;
      border-right: 1px solid ${mainColors.text_color_disabled};
      border-left: 1px solid ${mainColors.text_color_disabled};

      .location-icon {
        color: ${mainColors.text_color_disabled};
        margin-right: 4px;
      }

      p {
        margin: 4px 0;
      }
    }

    .price-info {
      padding: 0 8px;
      white-space: nowrap;
      justify-self: stretch;
    }

    @media only screen and (max-width: ${sizeStandards.screen.MD - 128}px) {
      grid-template-columns: 1fr;

      .court-contacts,
      .court-address,
      .price-info {
        width: 100%;
        padding: 0;
        text-align: center;
      }

      .court-address {
        margin: 8px 0;
        border: none;
      }

      .price-info {
        margin: 8px 0;
        white-space: normal;
      }
    }
  }

  .court-description {
    padding: 0 8px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: normal;

    max-height: calc(1.5em * 5); /* 5 lines of text */
    overflow-y: auto;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      max-height: calc(1.5em * 10);
    }
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;

    .reserve-button {
      padding: 8px;
      margin: 0;
      width: 120px;
      height: max-content;
      font-size: 14px;

      &:hover {
        box-shadow: 0px 0px 20px 0px ${mainColors.text_color};
      }

      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        width: 100%;
        padding: 4px 0;
      }
    }
  }

  .carousel-container {
    height: 57dvh;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      height: 250px;
    }

    .carousel-slider {
      width: 100% !important;
      height: 100%;
      user-select: none;
    }

    .selected img,
    .previous img {
      height: 450px;
      max-width: 1000px;
      object-fit: fill;

      @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
        height: 250px;
      }
      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        object-fit: cover;
      }
    }

    .control-arrow {
      height: 130px !important;
      top: calc(50% - 65px) !important;
      padding: 20px !important;
    }
  }
`;

export default CourtPreviewWrapper;
